import './Head.css'
import Carousel from '../Carousel/Carousel';
const Head = () => {

    return (
        <div className='Head'>
            <Carousel />
        </div>
    )
}

export default Head;